import { render, staticRenderFns } from "./AchievedDoughnutChart.vue?vue&type=template&id=5f422019&"
import script from "./AchievedDoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./AchievedDoughnutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports